import { isMobileHome, isModularHome } from './property-type-helpers';

export const FUNCTIONAL_REPLACEMENT_COST_YEAR_THRESHOLD = 1950;

export const isFunctionalReplacementCostApplied = (lossSettlement, yearBuilt) => {
  return lossSettlement === 'RC' && !!yearBuilt && yearBuilt <= FUNCTIONAL_REPLACEMENT_COST_YEAR_THRESHOLD;
};

export const getFunctionalReplacementCostText = (lossSettlement, yearBuilt) => {
  if (isFunctionalReplacementCostApplied(lossSettlement, yearBuilt)) {
    return 'Building loss settlement terms will be Functional Replacement Cost';
  }
  return undefined;
};

// FO-200 endorsement upgrade: the dec mapper rewrites the on-page
// Building Loss Settlement label to "Replacement Cost Terms - Mobile
// Home" when a dwelling carries mobile or modular property type with
// RC loss settlement. Staff-fe now surfaces the same upgrade via this
// help-text description (mirroring how Functional Replacement Cost is
// surfaced — the dropdown still shows the raw "Replacement Cost"
// option, but the helper text spells out what the dec will actually
// print). (#30735 audit alignment with farm-data-mapper.ts
// `isMobileOrModularRC` — same precedence: mobile/modular wins over
// Functional RC, so a pre-1950 mobile home gets the FO-200 wording
// rather than the FRC wording.)

export const isMobileHomeReplacementCostApplied = (lossSettlement, building) => {
  return lossSettlement === 'RC' && (isMobileHome(building) || isModularHome(building));
};

export const getMobileHomeReplacementCostText = (lossSettlement, building) => {
  if (isMobileHomeReplacementCostApplied(lossSettlement, building)) {
    return 'Building loss settlement terms will be Replacement Cost Terms - Mobile Home';
  }
  return undefined;
};

// Combined helper — pick whichever override applies, with mobile/modular
// winning over Functional RC to match the dec mapper's precedence
// (`farm-data-mapper.ts` per-risk `lossSettlement` derivation).
export const getLossSettlementDescriptionText = (lossSettlement, building, yearBuilt) => {
  return (
    getMobileHomeReplacementCostText(lossSettlement, building) ??
    getFunctionalReplacementCostText(lossSettlement, yearBuilt)
  );
};
